import { put, call, takeLatest } from 'redux-saga/effects'
import { getFeatureToggle } from 'services'
import { ACTION_TYPES } from 'store/reducers/featureToggle'

const {
  FEATURE_TOGGLE_REQUEST,
  FEATURE_TOGGLE_SUCCESS,
  FEATURE_TOGGLE_ERROR
} = ACTION_TYPES

export function *getToggle() {
  try {
    const response = yield call(getFeatureToggle)
    yield put({ type: FEATURE_TOGGLE_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: FEATURE_TOGGLE_ERROR, payload: err })
  }
}

export default function *watchFeatureToggle() {
  yield takeLatest(FEATURE_TOGGLE_REQUEST, getToggle)
}
